// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__99Adz","messageText":"Message_messageText__OF1qr"};